import { logOutAction } from '../../../api/auth';
import amplitude from '../../../util/amplitude';

export default () => {
  logOutAction();
  amplitude.getInstance().logEvent('Log Out');
  window.location.href = 'https://www.simpolium.com';
};
